<template>
<div class="page">
	<transition :name="transitionName">
		<div :key="currentPage" class="page-shell">
			<component :is="currentComp" class="page-main"
				@headerImageRefHeight="setScrolledHeight" :route-info="routeInfo" />
			<PageBottom />
		</div>
	</transition>
	<PageHeader :selected="currentPage" :menuItems="headerItems" :thresholdHeight="headerImageHeightPx"
		@changeDisplayingContent="headerClick" @height="headerComponentHeight = $event" />
</div>
</template>

<script>
import PageHeader from '@/components/header.vue'
import PageBottom from '@/components/bottom.vue'
import IndexPage from '@/pages/index_page.vue'
import AboutPage from '@/pages/about_page.vue'
import SolutionPage from '@/pages/solution_page.vue'
import ProductPage from '@/pages/product_page.vue'
import ServicesPage from '@/pages/services_page.vue'
import EnvironmentPage from '@/pages/environment_page.vue'
import CollaborationPage from '@/pages/collaboration_page.vue'
import NewsPage from '@/pages/news_page.vue'
import ContactPage from '@/pages/contact_page.vue'

export default {
	data() {
		return {
			currentPage: 0,
			transitionName: 'slide-left',
			headerItems: [
				{name: "首页", path: "index_page"},
				{name: "关于我们", path: "about_page"},
				{name: "解决方案", path: "solution_page"},
				{name: "平台产品", path: "product_page"},
				{name: "服务体系", path: "services_page"},
				{name: "品牌生态", path: "environment_page"},
				{name: "案例与合作", path: "collaboration_page"},
				// {name: "新闻洞察", path: "news_page"},
				{name: "联系我们", path: "contact_page"},
			],
			headerImageHeightPx: 0,
			headerComponentHeight: 0,

			subRouteParts: [], //新闻页子路由
		}
	},
	computed: {
		currentComp() {
			const map = ['IndexPage', 'AboutPage', 'SolutionPage', 'ProductPage', 'ServicesPage', 'EnvironmentPage', 'CollaborationPage', 'ContactPage'];
			return map[this.currentPage] || 'IndexPage';
		},
		routeInfo() {
			const pagePath = this.headerItems[this.currentPage]?.path || 'index_page';
			return { pagePath, parts: this.subRouteParts };
		}
	},
	methods : {
		onHashChange() {
			this.syncFromHash(false);
		},

		// 解析 hash：#news_page/12/3
		parseHash() {
			const raw = (window.location.hash || '').replace(/^#/, '');
			const [pagePath, ...parts] = raw.split('/').filter(Boolean);
			return { pagePath: pagePath || 'index_page', parts };
		},

		syncFromHash(isFirstLoad) {
			const { pagePath, parts } = this.parseHash();
			const index = this.headerItems.findIndex(i => i.path === pagePath);

			const nextPage = index === -1 ? 0 : index;
			const prevPage = this.currentPage;

			// 刷新首次进入不需要动画方向也行；你也可以保留
			if (!isFirstLoad) {
				this.transitionName = nextPage > prevPage ? 'slide-left' : 'slide-right';
			}

			this.currentPage = nextPage;
			this.subRouteParts = parts.slice();

			// 如果 hash 空的，补一个首页 hash（可选）
			if (!window.location.hash) {
				window.location.hash = this.headerItems[this.currentPage].path;
			}
		},

		headerClick(index) {
			this.transitionName = index > this.currentPage ? 'slide-left' : 'slide-right';
			this.currentPage = index;

			window.location.hash = this.headerItems[index].path;

			window.scrollTo(0, 0);
		},
		setScrolledHeight(height) {
			this.headerImageHeightPx = (Number(height) - this.headerComponentHeight) || 0;
		}
	},
	created() {
		const hash = window.location.hash.replace('#', '');
		const index = this.headerItems.findIndex(i => i.path === hash);
		if (index !== -1) {
			this.currentPage = index;
		}
	},
	mounted() {
		// window.addEventListener('hashchange', () => {
		// 	const hash = window.location.hash.replace('#', '');
		// 	const index = this.headerItems.findIndex(i => i.path === hash);
		// 	if (index !== -1) {
		// 		this.currentPage = index;
		// 	}
		// });

		this.syncFromHash(true);
		window.addEventListener('hashchange', this.onHashChange);
	},
	beforeDestroy() {
		window.removeEventListener('hashchange', this.onHashChange);
	},
	components: {
		PageHeader,
		PageBottom,
		IndexPage,
		AboutPage,
		SolutionPage,
		ProductPage,
		ServicesPage,
		EnvironmentPage,
		CollaborationPage,
		NewsPage,
		ContactPage,
	}
}
</script>

<style scoped>
.page{
	position: relative;
	background-color: #212121;
}

.page-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-main {
  flex: 1 1 auto;
  background-color: #FFFFFF;
}

/* 让进出场叠在一起滑动 */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 280ms ease, opacity 280ms ease;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

/* 往左滑：新页从右进，旧页往左出 */
.slide-left-enter {
  transform: translateX(20%);
  opacity: 0;
}
.slide-left-leave-to {
  transform: translateX(-20%);
  opacity: 0;
}

/* 往右滑：新页从左进，旧页往右出 */
.slide-right-enter {
  transform: translateX(-20%);
  opacity: 0;
}
.slide-right-leave-to {
  transform: translateX(20%);
  opacity: 0;
}
</style>
